"use client"

import { Plus } from "geist-icons";
import Link from "next/link";
import React from "react";
import { SquareFrameAI } from "./square-grid-ai";
import { PulseBeams } from "./chip-beam";

export default function AIHome() {
  return (
    <section className="w-full bg-[#FAFAFA] dark:bg-black min-w-[320px] flex items-center justify-center px-4 sm:px-6 md:px-8 lg:px-10">
      {/* Wrapper to control the width of the grid */}
      <div className="relative z-[20] w-full max-w-[1100px]">
        {/* Grid container with fixed height classes */}
        <div className="relative z-[50] w-full h-[600px] sm:h-[700px] md:h-[750px] lg:h-[860px] border-l-2 border-r-2 border-[#EAEAEA] dark:border-[#1E1E1E] flex flex-col mx-auto">
          <div className="absolute z-[30] lg:bottom-[59px] md:bottom-[51px] bottom-[64px] sm:bottom-[76px] md:-left-[11px] -left-[11px] flex items-center justify-center">
            <Plus className="text-[#A8A8A8] dark:text-[#878787] scale-100 md:scale-130" />
          </div>
          <SquareFrameAI>
            {/* Vertical grid lines */}
            <div className="absolute w-full h-full">
              <div className="relative h-full overflow-hidden z-[30] bottom-[62px] sm:bottom-[69px] md:bottom-[62px] lg:bottom-[71px]">
                <div className="mb-6 lg:mb-12 lg:ml-5 ml-2">
                  <div className="flex flex-row mr-5 md:mr-10 items-end justify-end z-20">
                    <h1 className="lg:text-6xl md:text-5xl text-4xl mt-20 mr-2 md:mr-4 lg:mr-5 font-bold pointer-events-auto z-30">
                      AI
                    </h1>
                    <h4 className="lg:text-4xl md:text-2xl text-xl mt-1 lg:mt-15 font-bold pointer-events-auto z-30">
                      for a smarter web
                    </h4>
                  </div>
                  <div className="flex flex-row md:gap-6 lg:gap-10 gap-4 mt-3 lg:mt-5 mr-5 md:mr-10 items-end justify-end">
                    <Link
                      href="/tools"
                      className="underline pointer-events-auto z-30"
                    >
                      Look at my tools
                    </Link>
                  </div>
                </div>
                <div className="absolute w-full top-10 sm:top-3 md:-top-4 lg:-top-2">
                  <PulseBeams />
                </div>
              </div>
              {/* For medium and large devices - three bottom vertical lines*/}
              <div className="absolute z-[10] left-[16.6%] md:bottom-[58px] lg:bottom-[71px] w-[1px] h-[150px] border border-[#EAEAEA] dark:border-[#1E1E1E] hidden md:block"></div>
              <div className="absolute z-[10] left-[49.95%] md:bottom-[58px] lg:bottom-[71px] w-[1px] h-[150px] border border-[#EAEAEA] dark:border-[#1E1E1E] hidden md:block"></div>
              <div className="absolute z-[10] left-[83.3%] md:bottom-[58px] lg:bottom-[71px] w-[1px] h-[150px] border border-[#EAEAEA] dark:border-[#1E1E1E] hidden md:block"></div>
              {/* For small devices - one bottom vertical line*/}
              <div className="absolute z-[10] left-[49.9%] sm:left-[49.8%] bottom-[74px] sm:bottom-[87px] w-[1px] h-[100px] sm:h-[130px] border border-[#EAEAEA] dark:border-[#1E1E1E] md:hidden block"></div>
            </div>
          </SquareFrameAI>
        </div>
      </div>
    </section>
  );
}
